import React from "react";

// Floating button icons. Keep keys/paths in sync with server/public/widget/embed.js (AW_SVG_ICONS)
// and server/config/widgetOptions.js (allowed values).
export const WIDGET_SVG_ICONS = {
  "access-circle":
    '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="6.5" r="1.6" fill="currentColor" stroke="none"/><path d="M7 9.5l5 1 5-1M12 10.5v3.5M12 14l-2.5 4.5M12 14l2.5 4.5"/>',
  "access-figure":
    '<circle cx="12" cy="4" r="2" fill="currentColor" stroke="none"/><path d="M4 8l8 1.5L20 8M12 9.5V14M12 14l-3.5 7M12 14l3.5 7"/>',
  wheelchair:
    '<circle cx="11" cy="3.8" r="1.8" fill="currentColor" stroke="none"/><path d="M11 7v6h5l2.5 5.5M11 9.5h4"/><path d="M8 11.2a5.5 5.5 0 1 0 7.6 6.3"/>',
  "wheelchair-active":
    '<circle cx="15" cy="3.8" r="1.8" fill="currentColor" stroke="none"/><path d="M13.5 7L11 12.5h5.5l1.5 6M12.5 9.5l4 .5"/><path d="M8.5 11a5.5 5.5 0 1 0 7 7"/>',
  eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
  ear: '<path d="M8 9a5 5 0 0 1 10 0c0 3-3 4-3 7a3 3 0 0 1-5.5 1.6"/><path d="M11 9.5a2 2 0 0 1 4 0c0 1.5-1.5 2-1.5 3"/>',
  "text-size": '<path d="M3 19l5-13 5 13M5 14.5h6M14 19l3.5-8 3.5 8M15.2 16.3h4.6"/>',
  contrast: '<circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor"/>',
  sliders:
    '<path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6"/><circle cx="12" cy="7.5" r="1.2" fill="currentColor" stroke="none"/>',
  globe:
    '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3z"/>',
  "heart-outline": '<path d="M12 20s-7-4.4-9-9a4.8 4.8 0 0 1 9-3 4.8 4.8 0 0 1 9 3c-2 4.6-9 9-9 9z"/>',
};

export const WIDGET_EMOJI_ICONS = {
  default: "♿",
  accessibility: "🌟",
  person: "👤",
  heart: "❤️",
  hand: "🤚",
  universal: "🌐",
};

export const WIDGET_ICON_OPTIONS = [
  { value: "access-circle", label: "סמל נגישות בעיגול" },
  { value: "access-figure", label: "דמות נגישות" },
  { value: "wheelchair", label: "כיסא גלגלים" },
  { value: "wheelchair-active", label: "כיסא גלגלים דינמי" },
  { value: "eye", label: "עין (ראייה)" },
  { value: "ear", label: "אוזן (שמיעה)" },
  { value: "text-size", label: "גודל טקסט (Aa)" },
  { value: "contrast", label: "ניגודיות" },
  { value: "sliders", label: "הגדרות (סליידרים)" },
  { value: "info", label: "מידע" },
  { value: "globe", label: "גלובוס" },
  { value: "heart-outline", label: "לב (קו)" },
  { value: "default", label: "♿ אמוג׳י כיסא גלגלים (ברירת מחדל)" },
  { value: "accessibility", label: "🌟 כוכב" },
  { value: "person", label: "👤 אדם" },
  { value: "heart", label: "❤️ לב" },
  { value: "hand", label: "🤚 יד" },
  { value: "universal", label: "🌐 אוניברסלי" },
  { value: "custom", label: "אייקון מותאם אישית (העלאת תמונה)" },
];

export const WIDGET_POSITION_OPTIONS = [
  { value: "bottom-right", label: "למטה מימין" },
  { value: "bottom-left", label: "למטה משמאל" },
  { value: "bottom-center", label: "למטה במרכז" },
  { value: "middle-right", label: "באמצע מימין" },
  { value: "middle-left", label: "באמצע משמאל" },
  { value: "top-right", label: "למעלה מימין" },
  { value: "top-left", label: "למעלה משמאל" },
  { value: "top-center", label: "למעלה במרכז" },
];

export function normalizeWidgetPosition(v) {
  const s = String(v || "").toLowerCase();
  if (s === "right" || s === "left" || s === "center") return `bottom-${s}`;
  return WIDGET_POSITION_OPTIONS.some((o) => o.value === s) ? s : "bottom-right";
}

export function WidgetIcon({ style, iconUrl, size = 24 }) {
  if (style === "custom" && iconUrl) {
    return <img src={iconUrl} alt="" style={{ width: size, height: size, objectFit: "contain", display: "block" }} />;
  }
  const svg = WIDGET_SVG_ICONS[style];
  if (svg) {
    return (
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        // Static, trusted markup from this file only
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    );
  }
  return (
    <span aria-hidden="true" style={{ fontSize: size, lineHeight: 1 }}>
      {WIDGET_EMOJI_ICONS[style] || WIDGET_EMOJI_ICONS.default}
    </span>
  );
}
